import React from "react"
import { Common } from "lib/types"
import { ReactComponent as DiscountIcon } from "images/icons/tags.svg"
import { PermissionGroups } from "../constants"

import { Discounts } from "views/Discounts"
import {
  ShowBundleGroups,
  ShowCodeGenerationJobs,
  ShowDiscountCodes,
  ShowDiscountRules,
  UpdateBundleGroup,
  UpdateCartRule,
  UpdateDiscountCodeRule,
  CreateBundleGroup,
  CreateDiscountRule
} from "views/Discounts"
import { UpdateExternalRule } from "views/Discounts/ExternalRule/UpdateExternalRule"

export const discountRoutes: Common.Views = [
  {
    element: <Discounts />,
    path: "/discounts",
    title: "Discounts",
    icon: DiscountIcon,
    sortOrder: 2,
    requiredGroups: PermissionGroups.discounts.read,
    children: [
      {
        element: <ShowBundleGroups />,
        path: "/discounts/bundle-groups/",
        title: "Bundle groups",
        parentPath: "/discounts",
        section: "Bundles"
      },
      {
        element: <UpdateBundleGroup />,
        path: "/discounts/bundle-groups/:id",
        title: "Edit group",
        parentPath: "/discounts",
        section: "Bundles"
      },
      {
        element: <CreateBundleGroup />,
        path: "/discounts/create-bundle-group/",
        title: "Create bundle group",
        parentPath: "/discounts",
        section: "Bundles",
        requiredGroups: PermissionGroups.discounts.write
      },
      {
        element: <ShowDiscountCodes />,
        path: "/discounts/discount-codes",
        title: "Discount codes",
        parentPath: "/discounts",
        section: "Discount code"
      },
      {
        element: <ShowCodeGenerationJobs />,
        path: "/discounts/code-generation-jobs/",
        title: "Code generation jobs",
        parentPath: "/discounts"
      },
      {
        element: <ShowDiscountRules />,
        path: "/discounts/discount-rules",
        title: "Discount rules",
        parentPath: "/discounts",
        section: "Discount rule"
      },
      {
        element: <CreateDiscountRule />,
        path: "/discounts/create-discount-rule",
        title: "Create discount rule",
        parentPath: "/discounts",
        requiredGroups: PermissionGroups.discounts.write
      },
      {
        element: <UpdateDiscountCodeRule />,
        path: "/discounts/discount-code-rules/:id",
        title: "Edit template",
        parentPath: "/discounts"
      },
      {
        element: <UpdateCartRule />,
        path: "/discounts/cart-rules/:id",
        title: "Update cart rule",
        parentPath: "/discounts"
      },
      {
        element: <UpdateExternalRule />,
        path: "/discounts/external-rules/:id",
        title: "Update external rule",
        parentPath: "/discounts"
      }
    ]
  }
]
